import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { CustomCmsVideoComponent } from '../../../models/cms-links.model'

@Component({
    selector: 'app-homepage-paragraph-section9',
    templateUrl: './homepage-paragraph-section9.component.html',
    styleUrl: './homepage-paragraph-section9.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HomepageParagraphSection9Component implements OnInit {
  public componentData: CustomCmsVideoComponent;

  constructor(public component: CmsComponentData<CustomCmsVideoComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
}
